import { render, staticRenderFns } from "./purchaseOrder.vue?vue&type=template&id=324ef64f&"
import script from "./purchaseOrder.vue?vue&type=script&lang=js&"
export * from "./purchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./purchaseOrder.vue?vue&type=style&index=0&id=324ef64f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports